export default "__VITE_ASSET__DbS6i0E7__"